import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TeamStore as MobxTeamStore } from 'nomst/Stores/team.store';
import BudgetConfigurationView from 'components/BudgetConfiguration/budgetConfigurationView';
import { WorkflowSettingsView } from 'nomst/Components/WorkflowSettings/workflowSettingsView';
import { ConfigViews } from 'typings/enums';
import CycleClosingAlert from 'nomst/Components/Decision/cycleClosingAlert';
import { PreviewCycleAlert } from 'nomst/Components/Decision/previewCycleAlert';
import { cycleRules, configurationsStore, budgetConfigurationViewStore } from 'utils/MobxDataManager/singletons';
import { CycleConfigMenu } from 'nomst/Components/Configuration/cycleConfigMenu';
import './cycleConfigurationView.scss';

export interface ICycleConfigurationsViewProps {
    store: MobxTeamStore;
}

export class CycleConfigurationsView extends React.Component<ICycleConfigurationsViewProps> {
    constructor(props: ICycleConfigurationsViewProps) {
        super(props);
    }

    render(): React.ReactNode {
        return (
            <div>
                <PreviewCycleAlert />
                <CycleClosingAlert />
                <div className="config cycle-config">
                    {this.renderConfigurations()}
                    {this.renderView()}
                </div>
            </div>
        );
    }

    private renderView(): React.ReactNode {
        const currentCycleConfiguration = configurationsStore.convertedCycleSettingsViewCycle;
        if (!currentCycleConfiguration) {
            return null;
        }

        if (configurationsStore.currentConfigView === ConfigViews.Budget) {
            return (
                <BudgetConfigurationView
                    budgetConfigurationViewStore={budgetConfigurationViewStore}
                    readonly={cycleRules.isCycleClosedForId(currentCycleConfiguration.cycleId)}
                />
            );
        }

        if (configurationsStore.currentConfigView === ConfigViews.Workflow) {
            return (
                <WorkflowSettingsView
                    workflowConfiguration={configurationsStore.convertedCycleSettingsViewCycle.workflowConfiguration}
                    readonly={cycleRules.isCycleClosedForId(configurationsStore.cycleSettingsId)}
                />
            );
        }

        return null;
    }

    private renderConfigurations(): React.ReactNode {
        return (
            <div className="cycle-configuration-sidebar">
                <CycleConfigMenu
                    cycleConfigs={configurationsStore.convertedConfigurations}
                    selectedCycleId={configurationsStore.convertedCycleSettingsViewCycle.cycleId}
                    currentView={configurationsStore.currentConfigView}
                    configurationsStore={configurationsStore}
                />
            </div>
        );
    }
}

export default inject('store')(observer(CycleConfigurationsView));
